<template>
  <v-card>
    <v-form @submit.prevent="submitAddVehicle()" ref="addVehicleForm">
      <v-card-title>
        <span class="headline">Add Vehicle {{isRequest || vehicle.request ? 'Request' : ''}}</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field label="* Registration" v-model="vehicle.name" :rules="nameRules"></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Vehicle Type"
              :items="vehicleTypes"
              v-model="vehicle.vehicleTypeId"
              item-text="name"
              item-value="id"
              :rules="vehicleTypeRules"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              label="* Contractor"
              :items="activeContractors"
              v-model="vehicle.contractorId"
              item-text="name"
              item-value="id"
              :rules="contractorRules"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Maximum Allowable Cartage Tonnage"
              v-model.number="vehicle.maxTonnage"
              :rules="maxTonnageRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Details" v-model="vehicle.details" :rules="detailsRules"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="VIN" v-model="vehicle.vin" :rules="vinRules"></v-text-field>
          </v-flex>
          <v-flex xs12 v-if="!isRequest">
            <v-switch label="Request" v-model="vehicle.request"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn
          :color="primaryNeutral"
          flat
          type="submit"
          :loading="addingVehicle"
        >{{ isRequest || vehicle.request ? 'Create Request' : 'Add'}}</v-btn>
      </v-card-actions>
    </v-form>
    <inductions-panel
      :projects="projects"
      :discarding="discarding"
      @selectedChanged="onSelectedChanged"
      @discard="discarding = false"
    ></inductions-panel>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import VehicleService from '@/services/requests/vehicleService'
import ContractorService from '@/services/requests/contractorService'

// MIXINS
import getVehicleTypes from '@/services/mixins/getMasterFiles/getVehicleTypes'
import VehicleValidation from '@/services/validation/vehicleValidation'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'

// COMPONENTS
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
import InductionsPanel from '@/components/ui/inductionsPanel'

export default {
  components: {
    DatePickerWrapper,
    InductionsPanel,
  },
  mixins: [VehicleValidation, getVehicleTypes, getProjects],
  props: {
    isRequest: Boolean,
  },
  data() {
    return {
      vehicle: {
        name: '',
        details: '',
        maxTonnage: null,
        vinNumber: null,
        contractorId: '',
        vehicleTypeId: '',
        request: false,
      },
      selectedProjects: [],
      addingVehicle: false,
      discarding: false,
    }
  },
  computed: {
    activeContractors: Store.getSet({
      store: 'contractors',
      prop: 'activeContractors',
    }),
  },
  methods: {
    submitAddVehicle() {
      if (!this.$refs.addVehicleForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.addVehicle()
    },
    addVehicle() {
      this.loading = true
      const postedVehicle = this.vehicle
      postedVehicle.selectedProjects = this.selectedProjects
      if (this.isRequest) this.vehicle.request = this.isRequest
      VehicleService.addVehicle(postedVehicle)
        .then((result) => {
          this.loading = false
          this.$store.commit('vehicles/addToArrayState', {
            prop: 'vehicles',
            value: result.data.result,
          })
          this.resetForm()
          this.snack({ color: 'green', text: 'Vehicle was added' })
          this.close()
          this.$emit('closeRequest')
        })
        .catch((err) => {
          this.snackError()
          this.addingVehicle = false
          console.log(err)
        })
    },
    onSelectedChanged(val) {
      this.selectedProjects = val
    },
    resetForm() {
      this.vehicle.name = ''
      this.vehicle.contactEmail = ''
      this.vehicle.contactPhone = ''
      this.vehicle.vinNumber = null
      this.vehicle.contractorId = ''
      this.vehicle.vehicleTypeId = ''
      this.$refs.addVehicleForm.resetValidation()
      this.discarding = true
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style>
</style>
